export default "__VITE_ASSET__CLBy8OWp__"